<div
  class="text-red"
  *ngIf="errorMessage !== null"
  [innerHTML]="errorMessage"
></div>
